module.exports = __webpack_public_path__ + "img/trello.fb1677f9.svg";